'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../utils/index');

require('./tooltip.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Tooltip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      tooltipSize = _ref.tooltipSize,
      target = _ref.target,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'tooltipSize', 'target']);

  var targetClientRect = target.getBoundingClientRect();
  var classes = (0, _index.cn)('tooltip', tooltipSize && 'tooltip--size-' + tooltipSize, className);

  return _reactDom2.default.createPortal(_react2.default.createElement(
    'div',
    _extends({
      className: classes
    }, props, {
      style: {
        top: targetClientRect.y + targetClientRect.height + window.pageYOffset,
        left: targetClientRect.x + targetClientRect.width / 2
      }
    }),
    children
  ), document.body);
}

Tooltip.propTypes = {
  className: _propTypes2.default.string,
  tooltipSize: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};

exports.default = Tooltip;